import type { Mastery } from "@/types/lex";

interface MasteryControlProps {
  value: Mastery;
  onChange: (value: Mastery) => void;
}

const OPTIONS: ReadonlyArray<[Exclude<Mastery, "untouched">, string]> = [
  ["unknown", "Unknown"],
  ["learning", "Learning"],
  ["known", "Known"],
];

const DOT: Record<Exclude<Mastery, "untouched">, "red" | "amber" | "moss"> = {
  unknown: "red",
  learning: "amber",
  known: "moss",
};

/**
 * Three-segment mastery toggle: Unknown / Learning / Known. Tapping the
 * currently-active option resets it to "untouched".
 */
export function MasteryControl({ value, onChange }: MasteryControlProps) {
  return (
    <div className="mastery-set">
      {OPTIONS.map(([k, label]) => {
        const active = value === k;
        return (
          <button
            key={k}
            className={`m-${k} ${active ? "is-active" : ""}`}
            onClick={() => onChange(active ? "untouched" : k)}
            type="button"
          >
            <span className={`dot dot--${DOT[k]}`} />
            {label}
          </button>
        );
      })}
    </div>
  );
}
